export default [
    {
        path: '/notas-cobros',
        name: 'notas-cobro',
        component: () => import('@/apps/notas_cobro/pages/notasCobroPage.vue')
      },
      {
        path: '/notas-cobro/no-generadas',
        name: 'notas-cobro-no-generadas',
        component: () => import('@/apps/notas_cobro/pages/notasCobroNoGeneradasPage.vue')
      },
      {
        path: '/notas-cobro-generar',
        name: 'notas-cobro-generar',
        component: () => import('@/apps/notas_cobro/pages/notasCobroGenerarPage.vue')
      },


]
  